import { cloneElement, HTMLAttributes, ReactElement } from 'react';
import classNames from 'classnames';
import { ImageAvatar, ImageAvatarProps } from '@components/avatar/ImageAvatar';
import './AvatarGroup.scss';

export interface AvatarGroupProps extends HTMLAttributes<HTMLDivElement> {
  /** the ImageAvatars to style for the group if not using items prop */
  children?: ReactElement[];
  /** use items array instead of children to generate the elements in this component */
  items?: Array<ImageAvatarProps>;
  className?: string;
}

/**
 * AvatarGroup - adds styles to an ImageAvatar list
 * @param children - the ImageAvatars to style for the group if not using items prop
 * @param items - use this instead of children to generate the elements in this component
 * @param className - optional class to pass to children wrapper
 */
export const AvatarGroup: React.FC<AvatarGroupProps> = ({
  children,
  items,
  className,
  ...rest
}) => {
  const imageAvatarGroup = items?.map((item, index) => (
    <ImageAvatar
      className="vds-avatar-group__item"
      {...item}
      key={index}
      style={{ left: -32 * index }}
    />
  ));

  const modifiedChildren = children?.map((child, index) => {
    const className = classNames(child.props.className, 'vds-avatar-group__item');
    const style = { left: -32 * index };

    return cloneElement(child, { className, style });
  });

  return (
    <div className={classNames('vds-avatar-group', className)} {...rest}>
      {items ? imageAvatarGroup : modifiedChildren}
    </div>
  );
};
